import { AdditionalFormNames, IAdditionalFormDefinition } from '../../models/form/IFormDefinition'
import { additionalIncomeBaseInfoFieldsDefinition, additionalIncomeInfoFieldValidations } from './AdditionalIncomeFields'

export const additionalIncomeForm: IAdditionalFormDefinition = {
   name: AdditionalFormNames.AdditionalIncomeForm, 
   additionalFields: additionalIncomeBaseInfoFieldsDefinition,
   label: "Dodatkowy dochód",
   switchLabel: 'Kliknij jeśli posiadasz dodatkowy dochód',
   formValidationFunctions: additionalIncomeInfoFieldValidations,
}